export function include(path) {
    const templates = {
        'modal/modal-anchor.j2': require('modal/modal-anchor.j2'),
        'modal/modal-close.j2': require('modal/modal-close.j2'),
        'modal/modal-contents.j2': require('modal/modal-contents.j2'),
        'modal/modal.j2': require('modal/modal.j2'),
        'modal/order-status.j2': require('modal/order-status.j2'),
        'modal/user/create/email-password.j2': require('modal/user/create/email-password.j2'),
        'modal/user/create/header.j2': require('modal/user/create/header.j2'),
        'modal/user/create/login-link.j2': require('modal/user/create/login-link.j2'),
        'modal/user/create/modal-create-contents.j2': require('modal/user/create/modal-create-contents.j2'),
        'modal/user/create/options.j2': require('modal/user/create/options.j2'),
        'modal/user/create/privacy-disclaimer.j2': require('modal/user/create/privacy-disclaimer.j2'),
        'modal/user/create/submit.j2': require('modal/user/create/submit.j2'),
        'modal/user/create.j2': require('modal/user/create.j2'),
        'modal/user/email-signup/email-signup-confirmation-form.j2': require('modal/user/email-signup/email-signup-confirmation-form.j2'),
        'modal/user/email-signup/email-signup-confirmation.j2': require('modal/user/email-signup/email-signup-confirmation.j2'),
        'modal/user/email-signup/email-signup-form.j2': require('modal/user/email-signup/email-signup-form.j2'),
        'modal/user/email-signup/email-signup.j2': require('modal/user/email-signup/email-signup.j2'),
        'modal/user/forgot-password/buttons.j2': require('modal/user/forgot-password/buttons.j2'),
        'modal/user/forgot-password/form-field.j2': require('modal/user/forgot-password/form-field.j2'),
        'modal/user/forgot-password/header.j2': require('modal/user/forgot-password/header.j2'),
        'modal/user/forgot-password/modal-forgot-password-contents.j2': require('modal/user/forgot-password/modal-forgot-password-contents.j2'),
        'modal/user/forgot-password/signin-signup.j2': require('modal/user/forgot-password/signin-signup.j2'),
        'modal/user/forgot-password.j2': require('modal/user/forgot-password.j2'),
        'modal/user/login/create-account-button.j2': require('modal/user/login/create-account-button.j2'),
        'modal/user/login/forgot-password-link.j2': require('modal/user/login/forgot-password-link.j2'),
        'modal/user/login/form-buttons.j2': require('modal/user/login/form-buttons.j2'),
        'modal/user/login/form-fields.j2': require('modal/user/login/form-fields.j2'),
        'modal/user/login/header.j2': require('modal/user/login/header.j2'),
        'modal/user/login/modal-login-contents.j2': require('modal/user/login/modal-login-contents.j2'),
        'modal/user/login/signup-link.j2': require('modal/user/login/signup-link.j2'),
        'modal/user/login.j2': require('modal/user/login.j2'),
        'invalid-template.j2': require('invalid-template.j2')
    };

    const template = templates[path];

    return this.env.filters.safe(template.render(this.ctx));
}
